import $ from 'jquery';

const ACTIVE = 'active';
let pageLoaded = 1;
let currentlyShown = $('a.active').text().toLowerCase();
const $ul = $('.testimonials-reviews ul');
const $loadMore = $('.testimonials-reviews a.load');

const getTestimonials = (data) => {
    data.page_key = 'flatpage_testimonials';
    data.version = 1;
    $.get('/testimonials/', data)
        .done((resp) => {
            const $newHtml = $(resp.actions.flatpage_testimonials.new_html);
            if (data.page === 1) {
                $ul.html($newHtml.find('li'));
            } else {
                $ul.append($newHtml.find('li'));
            }
            $loadMore.toggle($newHtml.filter('a.load.hidden').length === 0);
        });
};

export function toggleFeatured($target) {
    const links = $target.parent().find('a');

    $target.click((event) => {
        event.preventDefault();
        if (!$target.hasClass(ACTIVE)) {
            pageLoaded = 1;
            currentlyShown = $target.text().toLowerCase();
            getTestimonials({ view: currentlyShown, page: pageLoaded });
            links.removeClass(ACTIVE);
            $target.addClass(ACTIVE);
        }
    });
}


export function loadMore($target) {
    $target.toggle(!$target.hasClass('hidden'));

    $target.click((event) => {
        event.preventDefault();
        pageLoaded += 1;
        getTestimonials({ view: currentlyShown, page: pageLoaded });
    });
}
